//import {http} from '@/axios';

import axios from "axios";
import { authHeader } from "../helpers";

//baseURL: 'https://legajos.smarter.argenpesos.com.ar:50002/', // Reemplaza con la URL específica para la subida de archivos ((http://localhost:35784/))
const http = axios.create({
  baseURL: "https://legajos.smarter.argenpesos.com.ar:50002/", // Reemplaza con la URL específica para la subida de archivos ((http://localhost:35784/))
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

http.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    config.headers.Authorization = authHeader();

    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

const legajoVirtualService = {
  async uploadLegajoVirtual(
    documento,
    personaId,
    creditoId,
    empresaId,
    archivosASubirLegajo,
    completaDocumentacion,
    comentarios,
    tipoDocumentacion
  ) {
    const formData = new FormData();

    if (personaId) formData.append("personaId", personaId);
    if (documento) formData.append("documento", documento);
    if (creditoId) formData.append("creditoId", creditoId);

    formData.append("empresaId", empresaId);
    formData.append("tipoDocumentacion", tipoDocumentacion);
    formData.append("user", "-");

    if (completaDocumentacion) {
      formData.append("completaDocumentacion", completaDocumentacion);
      formData.append("comentarios", comentarios);
    }

    for (let i = 0; i < archivosASubirLegajo.length; i++) {
      formData.append("files", archivosASubirLegajo[i]);
    }

    try {
      await http.post("/api/files/upload", formData);
      return { success: true, message: "El legajo se completó con éxito." };
    } catch (error) {
      alert(JSON.stringify(error));
      return { success: false, message: error };
    }
  },
  async updatetipoArchivolegajovirtual(documento, fileName, tipoDocumentacion) {
    try {
      await http.put(
        "api/files/updateFileType",
        {
          documento,
          fileName,
          tipoDocumentacion,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return {
        success: true,
        message: "Se registraron los cambios con éxito.",
      };
    } catch (error) {
      return { success: false, message: error };
    }
  },
  async obtenerArchivosLegajo(documento, empresaId) {
    try {
      let endpoint = "";
      if (documento) {
        endpoint = `api/files/getfiles?documento=${documento}&empresaId=${empresaId}`;
      } else {
        alert("Documento no informado");
        //endpoint = `personas/getfileslegajovirtualporpersonaid?id=${personaId}&empresaId=${empresaId}`;
      }

      const { data } = await http.get(endpoint);

      return {
        success: true,
        data: data.map((archivo) => ({
          ...archivo,
          icon: obtenerIconoArchivo(archivo),
        })),
      };
    } catch (error) {
      alert("error");
      alert(error);
      return {
        success: false,
        message:
          error.response && error.response.data
            ? error.response.data
            : "Error al obtener archivos",
      };
      //throw error.response?.data || 'Error al obtener archivos';
    }
  },
  async obtenerArchivoLegajo(file) {
    try {
      if (!esImagenOPdf(file.extension)) {
        return {
          success: false,
          message: "Debe seleccionar un archivo con formato de imagen o PDF.",
        };
      }

      const base64String = b64EncodeUnicode(file.fullPath);
      const res = await http.get(`api/files/getfile/${base64String}`);
      var data = res.data;

      if (data.extension.toLowerCase() === ".pdf") {
        return { success: true, type: "pdf", content: data.file };
      } else {
        return { success: true, type: "image", content: data.file };
      }
    } catch (error) {
      return {
        success: false,
        message:
          error.response && error.response.data
            ? error.response.data
            : "Error al obtener archivo",
      };
    }
  },

  async descargarArchivoLegajo(file) {
    try {
      const base64String = b64EncodeUnicode(file.fullPath);
      const res = await http.get(`api/files/getfile/${base64String}`);

      var data = res.data;

      const dataType = obtenerDataType(data.extension);

      const arrayBuffer = base64ToArrayBuffer(data.file);
      guardarArchivo(data.fileName, arrayBuffer, dataType);

      return { success: true, message: "Descarga exitosa." };
    } catch (error) {
      alert(error);
      return {
        success: false,
        message:
          error.response && error.response.data
            ? error.response.data
            : "Error al descargar el archivo",
      };
    }
  },
  async eliminarArchivoLegajo(file) {
    try {
      const base64String = b64EncodeUnicode(file.fullPath); // Convertir el path a base64
      await http.delete(`api/files/delete/${base64String}`);
      return { success: true, message: "El archivo ha sido eliminado." };
    } catch (error) {
      return {
        success: false,
        message:
          error.response && error.response.data
            ? error.response.data
            : "Error al eliminar el archivo",
      };
    }
  },
};

export default legajoVirtualService;

// Función para codificar en Base64
const b64EncodeUnicode = (str) => {
  return btoa(unescape(encodeURIComponent(str)));
};

// Convertir base64 a ArrayBuffer
const base64ToArrayBuffer = (base64) => {
  let binaryString = atob(base64);
  let len = binaryString.length;
  let bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};

// Guardar el archivo en el sistema
const guardarArchivo = (fileName, arrayBuffer, dataType) => {
  const blob = new Blob([arrayBuffer], { type: dataType });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Función para obtener el tipo de archivo según la extensión
const obtenerDataType = (extension) => {
  const ext = extension.toLowerCase();
  const tipos = {
    ".doc": "application/vnd.ms-word",
    ".docx":
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ".pdf": "application/pdf",
  };
  return tipos[ext] || null;
};

// Función para verificar si es una imagen o PDF
const esImagenOPdf = (extension) => {
  const ext = extension.toLowerCase();
  return [".jpg", ".jpeg", ".png", ".pdf"].includes(ext);
};

const obtenerIconoArchivo = (archivo) => {
  if (archivo.tipo === "SinEspecificar") {
    switch (archivo.extension.toLowerCase()) {
      case ".jpg":
      case ".png":
        return "insert_photo";
      case ".pdf":
        return "file_copy";
      case ".doc":
      case ".docx":
        return "format_list_bulleted";
      default:
        return "attach_file";
    }
  }

  const iconosPorTipo = {
    Documentacion: "description",
    LegajoCredito: "how_to_reg",
    Grabaciones: "mic",
    ComprobantePago: "payment",
    Interno: "lock",
  };

  return iconosPorTipo[archivo.tipo] || "attach_file";
};
